import { Component } from '@angular/core';

@Component({
  selector: 'app-jcb-icon',
  templateUrl: './jcb-icon.component.html',
  styleUrl: './jcb-icon.component.scss'
})
export class JcbIconComponent {

}
